/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import isApiError from "@insite/client-framework/Common/isApiError";
import { updateAccount, UpdateAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { addAccount, AddAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { post ,ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

export async function updateAccountWithResult(
    parameter: UpdateAccountApiParameter,
): Promise<ServiceResult<AccountModel>> {
    try {
        const updatedAccount = await updateAccount(parameter);
        return {
            successful: true,
            result: updatedAccount,
        };
    } catch (error) {
        // xng-change - check if the status of error is 403
        if ((isApiError(error) && error.status === 400) || error.status === 403) {
            return {
                successful: false,
                errorMessage: (error.status === 403 ? error.errorMessage : error.errorJson.message) ,
            };
        }
        throw error;
    }
}

export async function xngaddAccount(parameter: AddAccountApiParameter): Promise<ServiceResult<AccountModel>> {
    try {
        const accountModel = await post<AccountModel>(`${"/api/v1/accounts"}`, parameter.account as AccountModel);
        return {
            result: accountModel,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && (error.status === 403 || (error.status === 400 && error.errorJson && error.errorJson.message))){
            return {
                successful: false,
                errorMessage: (error.status === 403 ? error.errorMessage : error.errorJson.message) ,
            };
        }
        throw error;
    }
}
